var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _vm.inPreview
        ? _c("pdf-preview", {
            attrs: {
              inPreview: _vm.inPreview,
              generatingPreview: _vm.generatingPreview,
              saving: _vm.saving,
              pdfUrl: _vm.pdfUrl,
              backToForm: _vm.backToForm,
              save: _vm.save
            }
          })
        : _c(
            "div",
            [
              _c(
                "form",
                {
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c("h2", [_vm._v("INFORME DE ACTIVIDADES")])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", { attrs: { for: "formType" } }, [
                                _vm._v(" ¿Deseas basarte en otro documento? ")
                              ]),
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.createdDocuments,
                                    name: "previousDocument",
                                    label: "label",
                                    "data-cy": "created-document-data",
                                    clearable: true
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.getDocumentData($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.previousDocument,
                                    callback: function($$v) {
                                      _vm.previousDocument = $$v
                                    },
                                    expression: "previousDocument"
                                  }
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(" no hay documentos registrados ")
                                  ])
                                ],
                                2
                              ),
                              _vm.$validator.errors.has("formType")
                                ? _c("v-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$validator.errors.first(
                                            "formType"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      !_vm.attachments || !_vm.attachments.length
                        ? _c(
                            "div",
                            { staticClass: "col-12 mb-4" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "ED060",
                                      expression: "'ED060'"
                                    },
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal",
                                      value: "add-repository-file",
                                      expression: "'add-repository-file'"
                                    }
                                  ],
                                  staticClass: "btn-icon mt-1 w-100",
                                  attrs: {
                                    variant: "secondary",
                                    "data-cy": "from-repository",
                                    disabled: _vm.attachments.length >= 1
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "ServerIcon" }
                                  }),
                                  _vm._v(
                                    " Seleccionar CPSH desde el repositorio "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.attachments, function(file) {
                        return file && file.name && file.name.includes("CPSH")
                          ? _c("div", { key: file.id, staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c("vs-icon", {
                                    staticClass: "col-2",
                                    attrs: {
                                      icon: "description",
                                      size: "25px",
                                      color: "primary"
                                    }
                                  }),
                                  _c(
                                    "b",
                                    { staticClass: "w-100 text-center col-8" },
                                    [_vm._v(_vm._s(file.name))]
                                  ),
                                  _c("vs-button", {
                                    staticClass: "col-2",
                                    attrs: {
                                      color: "danger",
                                      type: "flat",
                                      icon: "clear"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRepositoryFile(file.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      }),
                      !_vm.attachments || !_vm.attachments.length
                        ? _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "danger span-text-validation-danger v-enter-to"
                              },
                              [
                                _c("small", [
                                  _vm._v(
                                    " Debes seleccionar un archivo desde el repositorio "
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.attachments && _vm.attachments.length && !_vm.loading
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [_c("vs-divider")],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "responsibleName",
                                label: "Nombre colaborador"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "responsibleName",
                                            placeholder: "Nombre colaborador",
                                            "data-vv-as": "nombre",
                                            "data-cy": "responsible-name",
                                            state: invalid,
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.formData.responsibleName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "responsibleName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.responsibleName"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2723093005
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "responsibleBoss",
                                label: "Nombre Jefatura"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "responsibleBoss",
                                            placeholder: "Jefatura",
                                            "data-vv-as": "jefatura",
                                            "data-cy": "responsible-boss",
                                            state: invalid,
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.formData.responsibleBoss,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "responsibleBoss",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.responsibleBoss"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2933983649
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "administrativeSupport",
                                label: "Soporte administrativo"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "administrativeSupport",
                                            placeholder:
                                              "Soporte administrativo",
                                            "data-vv-as":
                                              "soporte administrativo",
                                            "data-cy": "administrative-support",
                                            state: invalid,
                                            disabled: ""
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .administrativeSupport,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "administrativeSupport",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.administrativeSupport"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                605989947
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "performanceUnit",
                                label: "Unidad de desempeño"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "performanceUnit",
                                            placeholder: "Unidad de desempeño",
                                            "data-vv-as": "Unidad de desempeño",
                                            "data-cy": "performance-unit",
                                            state: invalid,
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.formData.performanceUnit,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "performanceUnit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.performanceUnit"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3936114614
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "startPeriodDate",
                                label: "Inicio periodo"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("date-picker", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-100",
                                          attrs: {
                                            name: "startPeriodDate",
                                            placeholder: "Inicio periodo",
                                            "data-vv-as": "Inicio periodo",
                                            "data-cy": "start-period-date",
                                            format: "DD/MM/YYYY",
                                            "value-type": "DD/MM/YYYY",
                                            state: invalid
                                          },
                                          model: {
                                            value: _vm.formData.startPeriodDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "startPeriodDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.startPeriodDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4021531458
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "endPeriodDate",
                                label: "Fin periodo"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("date-picker", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-100",
                                          attrs: {
                                            name: "endPeriodDate",
                                            placeholder: "Fin periodo",
                                            "data-vv-as": "Fin periodo",
                                            "data-cy": "end-period-date",
                                            format: "DD/MM/YYYY",
                                            "value-type": "DD/MM/YYYY",
                                            state: invalid
                                          },
                                          model: {
                                            value: _vm.formData.endPeriodDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "endPeriodDate",
                                                $$v
                                              )
                                            },
                                            expression: "formData.endPeriodDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3420068397
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "decreeNumber",
                                label: "N° Decreto"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "decreeNumber",
                                            placeholder: "N° Decreto",
                                            "data-vv-as": "N° Decreto",
                                            "data-cy": "decree-number",
                                            state: invalid,
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.formData.decreeNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "decreeNumber",
                                                $$v
                                              )
                                            },
                                            expression: "formData.decreeNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2535132891
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "feeBillNumber",
                                label: "N° Boleta de honorario"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "feeBillNumber",
                                            placeholder:
                                              "N° Boleta de honorario",
                                            "data-vv-as":
                                              "N° Boleta de honorario",
                                            "data-cy": "fee-bill-number",
                                            state: invalid
                                          },
                                          model: {
                                            value: _vm.formData.feeBillNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "feeBillNumber",
                                                $$v
                                              )
                                            },
                                            expression: "formData.feeBillNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3172611341
                              )
                            })
                          ],
                          1
                        ),
                        _vm.isDocenteForm
                          ? _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c("validate-field", {
                                  attrs: {
                                    field: "totalHours",
                                    label: "N° horas totales según contrato"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          return [
                                            _c("b-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              attrs: {
                                                name: "totalHours",
                                                placeholder:
                                                  "N° horas totales según contrato",
                                                "data-vv-as":
                                                  "N° horas totales según contrato",
                                                "data-cy": "total-hours",
                                                state: invalid
                                              },
                                              model: {
                                                value: _vm.formData.totalHours,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "totalHours",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.totalHours"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3711121567
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isDocenteForm
                          ? _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c("validate-field", {
                                  attrs: {
                                    field: "subjectName",
                                    label: "Nombre de asignatura"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                class: {
                                                  "v-select-danger":
                                                    invalid === false
                                                },
                                                attrs: {
                                                  options: _vm.subjectsCreated,
                                                  name: "subjectSelected",
                                                  label: "label",
                                                  "data-vv-as":
                                                    "Nombre de asignatura",
                                                  "data-cy": "subject-name",
                                                  multiple: "",
                                                  "v-validate": {
                                                    required: _vm.isDocenteForm
                                                  },
                                                  clearable: true
                                                },
                                                on: { input: _vm.addSubject },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .subjectSelected,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "subjectSelected",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.subjectSelected"
                                                }
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "no-options" },
                                                  [
                                                    _vm._v(
                                                      " no hay asignaturas registradas "
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3427267467
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isDocenteForm
                          ? _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c("validate-field", {
                                  attrs: {
                                    field: "classSchedule",
                                    label: "Horario de clases"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                class: {
                                                  "v-select-danger":
                                                    invalid === false
                                                },
                                                attrs: {
                                                  options: _vm.schedulesCreated,
                                                  name: "scheduleSelected",
                                                  label: "label",
                                                  placeholder:
                                                    "Horario de clases",
                                                  "data-vv-as":
                                                    "Horario de clases",
                                                  "data-cy": "class-schedule",
                                                  "v-validate": {
                                                    required: _vm.isDocenteForm
                                                  },
                                                  multiple: "",
                                                  clearable: true
                                                },
                                                on: { input: _vm.addSchedule },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .classScheduleSelected,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "classScheduleSelected",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.classScheduleSelected"
                                                }
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "no-options" },
                                                  [
                                                    _vm._v(
                                                      " no hay horarios registrados "
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1736197814
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isDocenteForm
                          ? _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c("validate-field", {
                                  attrs: {
                                    field: "totalEffectiveHours",
                                    label: "N° de horas efectivas"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          return [
                                            _c("b-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              attrs: {
                                                name: "totalEffectiveHours",
                                                placeholder:
                                                  "N° de horas efectivas",
                                                "data-vv-as":
                                                  "N° de horas efectivas",
                                                "data-cy":
                                                  "total-effective-hours",
                                                state: invalid
                                              },
                                              model: {
                                                value:
                                                  _vm.formData
                                                    .totalEffectiveHours,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "totalEffectiveHours",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.totalEffectiveHours"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    4019670271
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "col-12" }, [
                          _c("h4", [_vm._v("DATOS DE TRANSFERENCIA")])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: { field: "bank", label: "Banco" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c(
                                          "b-form-select",
                                          {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "w-100",
                                            attrs: {
                                              disabled: _vm.loadingBankOptions,
                                              "data-vv-as": "Banco",
                                              "data-cy": "bank",
                                              state: invalid,
                                              name: "bank",
                                              options: _vm.bankOptions
                                            },
                                            model: {
                                              value: _vm.formData.bank,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "bank",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.bank"
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: { disabled: "" },
                                                domProps: { value: null }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.bankLoadingText
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3489527601
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "bankAccountType",
                                label: "Tipo de cuenta"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c(
                                          "b-form-select",
                                          {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "bankAccountType",
                                              placeholder: "Tipo de cuenta",
                                              "data-vv-as": "Tipo de cuenta",
                                              "data-cy": "bank-account-type",
                                              state: invalid,
                                              options: _vm.bankAccountTypes
                                            },
                                            model: {
                                              value:
                                                _vm.formData.bankAccountType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "bankAccountType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.bankAccountType"
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  disabled: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "-- Selecciona un tipo de cuenta --"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1297847593
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("validate-field", {
                              attrs: {
                                field: "bankAccountNumber",
                                label: "N° de cuenta"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      return [
                                        _c("b-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "bankAccountNumber",
                                            placeholder: "N° de cuenta",
                                            "data-vv-as": "N° de cuenta",
                                            "data-cy": "bank-account-number",
                                            state: invalid
                                          },
                                          model: {
                                            value:
                                              _vm.formData.bankAccountNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "bankAccountNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.bankAccountNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3123266951
                              )
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-12" }, [
                          _c("h4", [
                            _vm._v(
                              "ACTIVIDADES REALIZADAS O PRODUCTO ENTREGADO EN EL MES INFORMADO"
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-12 col-lg-12" },
                          _vm._l(_vm.formData.activities, function(
                            service,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "key-" + index,
                                staticClass: "wrap-functions"
                              },
                              [
                                _c("b", [
                                  _vm._v("Función " + _vm._s(index + 1) + ":")
                                ]),
                                _vm._v(" " + _vm._s(service.task) + " ")
                              ]
                            )
                          }),
                          0
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 mt-10" },
                          [
                            _c(
                              "vs-table",
                              {
                                staticClass: "wrap-table shadow",
                                attrs: {
                                  hoverFlat: "",
                                  data: _vm.formData.activitiesPeriod || [],
                                  noDataText: "No hay actividades aún"
                                }
                              },
                              [
                                [
                                  _c("thead", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "3" }
                                      },
                                      [
                                        _c("h4", [
                                          _vm._v(
                                            "ACTIVIDADES REALIZADAS O PRODUCTO ENTREGADO EN EL MES INFORMADO"
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.formData.activitiesPeriod,
                                      function(_, index) {
                                        return _c(
                                          "vs-tr",
                                          { key: index },
                                          [
                                            _c(
                                              "vs-td",
                                              { staticClass: "table-part" },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "relatedActivity"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(" Cometidos "),
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.required(
                                                                "activitiesPeriod[" +
                                                                  index +
                                                                  "].relatedActivity"
                                                              )
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _c("v-select", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      class: {
                                                        "v-select-danger": _vm.$validator.errors.has(
                                                          "activities[" +
                                                            index +
                                                            "].relatedActivity"
                                                        )
                                                      },
                                                      attrs: {
                                                        "data-cy":
                                                          "activitiesPeriod[" +
                                                          index +
                                                          "].relatedActivity",
                                                        name:
                                                          "activitiesPeriod[" +
                                                          index +
                                                          "].relatedActivity",
                                                        "data-vv-as":
                                                          "cometido",
                                                        placeholder:
                                                          "Cometido...",
                                                        state: _vm.$validator.errors.has(
                                                          "activitiesPeriod[" +
                                                            index +
                                                            "].relatedActivity"
                                                        )
                                                          ? false
                                                          : null,
                                                        danger: _vm.$validator.errors.has(
                                                          "activitiesPeriod[" +
                                                            index +
                                                            "].relatedActivity"
                                                        ),
                                                        "danger-text": _vm.$validator.errors.first(
                                                          "activitiesPeriod[" +
                                                            index +
                                                            "].relatedActivity"
                                                        ),
                                                        options:
                                                          _vm.formData
                                                            .activitiesSelect
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          _vm.formData.activitiesPeriod[
                                                            index
                                                          ].nameActivity =
                                                            $event.label
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formData
                                                            .activitiesPeriod[
                                                            index
                                                          ].relatedActivity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formData
                                                              .activitiesPeriod[
                                                              index
                                                            ],
                                                            "relatedActivity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formData.activitiesPeriod[index].relatedActivity"
                                                      }
                                                    }),
                                                    _vm.$validator.errors.has(
                                                      "activitiesPeriod[" +
                                                        index +
                                                        "].relatedActivity"
                                                    )
                                                      ? _c(
                                                          "v-invalid-feedback",
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$validator.errors.first(
                                                                    "activitiesPeriod[" +
                                                                      index +
                                                                      "].relatedActivity"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "vs-td",
                                              [
                                                _c(
                                                  "b-form-group",
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "activitiesPeriod[" +
                                                            index +
                                                            "].descriptionActivity"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Descripción de la función "
                                                        ),
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.required(
                                                                "activitiesPeriod[" +
                                                                  index +
                                                                  "].descriptionActivity"
                                                              )
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _c("b-form-textarea", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      attrs: {
                                                        rows: "3",
                                                        name:
                                                          "activitiesPeriod[" +
                                                          index +
                                                          "].descriptionActivity",
                                                        "data-cy":
                                                          "activitiesPeriod[" +
                                                          index +
                                                          "].descriptionActivity",
                                                        "data-vv-as":
                                                          "descripción de la función",
                                                        placeholder:
                                                          "Descripción de la función y/o producto realizado",
                                                        danger: _vm.$validator.errors.has(
                                                          "activitiesPeriod[" +
                                                            index +
                                                            "].descriptionActivity"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formData
                                                            .activitiesPeriod[
                                                            index
                                                          ].descriptionActivity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formData
                                                              .activitiesPeriod[
                                                              index
                                                            ],
                                                            "descriptionActivity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formData.activitiesPeriod[index].descriptionActivity"
                                                      }
                                                    }),
                                                    _vm.$validator.errors.has(
                                                      "activitiesPeriod[" +
                                                        index +
                                                        "].descriptionActivity"
                                                    )
                                                      ? _c(
                                                          "v-invalid-feedback",
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$validator.errors.first(
                                                                    "activitiesPeriod[" +
                                                                      index +
                                                                      "].descriptionActivity"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "vs-td",
                                              { staticClass: "align-middle" },
                                              [
                                                _c("vs-button", {
                                                  staticClass: "-mb-3",
                                                  attrs: {
                                                    color: "danger",
                                                    type: "border",
                                                    icon: "delete"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeActivity(
                                                        index
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "tfoot",
                                    [
                                      _c(
                                        "vs-tr",
                                        [
                                          _c(
                                            "vs-td",
                                            { attrs: { colspan: "3" } },
                                            [
                                              _c(
                                                "vs-button",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    color: "primary",
                                                    type: "border",
                                                    icon: "add"
                                                  },
                                                  on: { click: _vm.addActivity }
                                                },
                                                [_vm._v(" Agregar Actividad ")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "vs-tr",
                                        [
                                          _c(
                                            "vs-td",
                                            { attrs: { colspan: "3" } },
                                            [
                                              _vm.activitiesError
                                                ? _c(
                                                    "v-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        "data-cy":
                                                          "activitiesError"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.activitiesError
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 mt-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "experience" } }, [
                                  _vm._v(" Observaciones "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.required("notes"))
                                    }
                                  })
                                ]),
                                _c("b-form-textarea", {
                                  attrs: {
                                    rows: "3",
                                    "data-cy": "observaciones",
                                    name: "notes",
                                    "data-vv-as": "Observaciones",
                                    placeholder: "Observaciones...",
                                    state: _vm.$validator.errors.has("notes")
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has("notes"),
                                    "danger-text": _vm.$validator.errors.first(
                                      "notes"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.notes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "notes", $$v)
                                    },
                                    expression: "formData.notes"
                                  }
                                }),
                                _vm.$validator.errors.has("notes")
                                  ? _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first("notes")
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-12" }, [
                          _c("h4", [_vm._v("Documentos")])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            !_vm.actAttachmentsSelectors.loading
                              ? _c("dynamic-file-selector", {
                                  attrs: {
                                    selectors: _vm.actAttachmentsSelectors.list
                                      .slice()
                                      .sort(function(a, b) {
                                        return a.order - b.order
                                      })
                                      .map(function(sel) {
                                        return Object.assign(
                                          {},
                                          sel,
                                          sel.extra,
                                          { index: sel.order }
                                        )
                                      }),
                                    "object-to-evaluate": _vm.formData,
                                    files: _vm.dynamicSelectorFiles,
                                    "reset-key": _vm.dfsResetKey
                                  },
                                  on: {
                                    "update-files": _vm.updateFiles,
                                    valid: function(valid) {
                                      _vm.dynamicFileSelectorValid = valid
                                    }
                                  }
                                })
                              : _c(
                                  "div",
                                  [
                                    _c("b-skeleton", {
                                      attrs: {
                                        animation: "fade",
                                        width: "100%"
                                      }
                                    }),
                                    _c("b-skeleton", {
                                      attrs: {
                                        animation: "fade",
                                        width: "100%"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ],
                          1
                        ),
                        _vm.error.message !== ""
                          ? _c(
                              "div",
                              { staticClass: "col-12 text-right" },
                              [
                                _c("v-invalid-feedback", [
                                  _vm._v(" " + _vm._s(_vm.error.message) + " ")
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              ),
              _c("small", [
                _c("b", [
                  _vm._v("Los campos marcados con "),
                  _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
                  _vm._v(" son obligatorios")
                ])
              ]),
              _c("form-action-buttons", {
                attrs: {
                  saving: _vm.saving,
                  preview: _vm.preview,
                  back: _vm.back,
                  save: _vm.save,
                  saveDraft: _vm.saveDraft
                }
              }),
              _c("repository-selector", {
                attrs: {
                  "add-file": _vm.addRepositoryFile,
                  files: _vm.attachments,
                  "remove-file": _vm.removeRepositoryFile,
                  "max-files": 1,
                  "required-file-type": "CPSH",
                  "required-approval-state": _vm.approvalStateTypes.APPROVED
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }